import useViewportWidth, { useViewportHeight } from "./useViewportWidth";

/**
 * A phone on its side (#149), e.g. mounted on a rower or bike: wider than
 * tall and short. Desktop windows (1024 px and up) keep their own layout.
 */
const usePhoneLandscape = () => {
  const w = useViewportWidth();
  const h = useViewportHeight();
  return w < 1024 && w > h && h <= 600;
};

export default usePhoneLandscape;
